import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { staffApi } from '../api/staff';
import { CreateOrUpdateRole } from '../types/role';

export const useUpdateRole = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({
      roleId,
      role,
    }: {
      roleId: number;
      role: CreateOrUpdateRole;
    }) => staffApi.updateRole(roleId, role),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['roles'] });
      message.success('Papel editado com sucesso!');
    },
    onError: () => {
      message.error('Falha ao editar o papel. Tente novamente!');
    },
  });

  const { mutateAsync, isPending: isLoading, ...rest } = mutation;

  return { mutateAsync, isLoading, ...rest };
};
